import { DEMO_CONFIG } from "./demo.config";

type BalanceListener = (balance: number) => void;

const toMinorUnits = (amount: number) => Math.round(amount * 100);
const fromMinorUnits = (amount: number) => amount / 100;

export class DemoWalletService {
  private balanceInCents = toMinorUnits(DEMO_CONFIG.initialDemoBalance);
  private readonly listeners = new Set<BalanceListener>();

  getBalance(): number {
    return fromMinorUnits(this.balanceInCents);
  }

  canDebit(amount: number): boolean {
    const cents = toMinorUnits(amount);
    return Number.isFinite(amount) && cents > 0 && cents <= this.balanceInCents;
  }

  debit(amount: number): boolean {
    if (!this.canDebit(amount)) return false;

    this.balanceInCents -= toMinorUnits(amount);
    this.emit();
    return true;
  }

  credit(amount: number): boolean {
    const cents = toMinorUnits(amount);
    if (!Number.isFinite(amount) || cents <= 0) return false;

    this.balanceInCents += cents;
    this.emit();
    return true;
  }

  reset(): void {
    this.balanceInCents = toMinorUnits(DEMO_CONFIG.initialDemoBalance);
    this.emit();
  }

  subscribe(listener: BalanceListener): () => void {
    this.listeners.add(listener);
    listener(this.getBalance());
    return () => this.listeners.delete(listener);
  }

  private emit(): void {
    const balance = this.getBalance();
    this.listeners.forEach((listener) => listener(balance));
  }
}
